export default __webpack_public_path__ + "static/media/skillwavetop.b581b78c.png";